import "../../dist/css/gigpost.css";
import { Button, Box, Flex } from "@chakra-ui/react";
import { Steps, theme } from "antd";
import { useState } from "react";
import StepsSideBar from "./StepsSideBar";
import JobTitle from "./JobTitle";
import JobDescription from "./Description";
import JobDetails from "./Details";
import JobExpertise from "./Expertise";
import JobVisibility from "./Visibility";
import JobBudget from "./Budget";
import JobPostDone from "./JobPostDone";

const JobPostLayout = () => {
  const { token } = theme.useToken();
  const [current, setCurrent] = useState(0);
  const prev = () => {
    setCurrent(current - 1);
  };
  const steps = [
    {
      title: (
        <Box
          onClick={() => {
            setCurrent(0);
          }}
          cursor="pointer"
        >
          Job Title
        </Box>
      ),
      content: <JobTitle />,
    },
    {
      title: (
        <Box
          onClick={() => {
            setCurrent(1);
          }}
          cursor="pointer"
        >
          Description
        </Box>
      ),
      content: <JobDescription />,
    },
    {
      title: (
        <Box
          onClick={() => {
            setCurrent(2);
          }}
          cursor="pointer"
        >
          Details
        </Box>
      ),
      content: <JobDetails />,
    },
    {
      title: (
        <Box
          onClick={() => {
            setCurrent(3);
          }}
          cursor="pointer"
        >
          Expertise
        </Box>
      ),
      content: <JobExpertise />,
    },
    {
      title: (
        <Box
          onClick={() => {
            setCurrent(4);
          }}
          cursor="pointer"
        >
          Visibility
        </Box>
      ),
      content: <JobVisibility />,
    },
    {
      title: (
        <Box
          onClick={() => {
            setCurrent(5);
          }}
          cursor="pointer"
        >
          {" "}
          Budget
        </Box>
      ),
      content: <JobBudget />,
    },
    // {
    //   title: (
    //     <Box
    //       onClick={() => {
    //         setCurrent(6);
    //       }}
    //       cursor="pointer"
    //     >
    //       {" "}
    //       Review
    //     </Box>
    //   ),
    //   content: <JobReview prev={prev} />,
    // },
  ];
  const next = () => {
    setCurrent(current + 1);
  };
  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));
  const contentStyle = {
    lineHeight: "100vh",
    textAlign: "center",
    width: "98%",
  };
  return (
    <>
      <StepsSideBar>
        <Box>
          <Steps
            current={current}
            className="gigpost_Container_steps"
            items={items}
            direction={"vertical"}
            responsive={true}
            size="small"
            labelPlacement="vertical"
          />
        </Box>
      </StepsSideBar>
      <Flex>
        <Box
          px={{ base: "0",md:4, xl: "10" }}
          display={{ base: "none", md: "none", lg: "block" }}
          gap={{ lg: "5" }}
        >
          <Steps
            current={current}
            className="gigpost_Container_steps"
            items={items}
            direction={"vertical"}
            responsive={true}
            size="small"
            labelPlacement="vertical"
          />
        </Box>
        <Box
          style={contentStyle}
          borderLeft={{
            sm: "none",
            md: "none",
            lg: `2px solid ${token.colorBorder}`,
          }}
          pl={{ lg: 10 }}
        >
          {steps[current].content}
        </Box>
      </Flex>
      <Flex
        mt={44}
        borderTop="1px solid #c5c5c5"
        pt={5}
        gap={4}
        justifyContent={{
          base: "space-evenly",
          md: "flex-end",
        }}
      >
        {current === steps.length - 1 && <JobPostDone />}
        {current > 0 && current < steps.length - 1 && (
          <Button
            style={{
              margin: "0 8px",
            }}
            mx="8px"
            bg="#c5c5c5"
            onClick={() => prev()}
          >
            Go Back
          </Button>
        )}
        {current < steps.length - 1 && (
          <Button colorScheme="brand" onClick={() => next()}>
            Continue
          </Button>
        )}
      </Flex>
    </>
  );
};

export default JobPostLayout;
